'use strict';

import versioner from '../versioner';
import process from './process';

versioner['jcw_bupp'] = {
	process: process,
}

const MODULE_NAME = 'daupler.incidents.versions.jcwBupp';

export default MODULE_NAME;
